import React from 'react';
import { ColumnsType } from 'antd/lib/table';
import { getI18n } from 'react-i18next';
import TableHeader from '~/pages/agent/components/agent/tableElements/TableHeader';
import { CellText } from '~/pages/agent/components/agent/tableElements/cells/CellText';

function crUnifiedNumberCell(): ColumnsType<any>[0] {
  return {
    title: () => (
      <TableHeader title={getI18n().t('CR Unified Number', { ns: 'agent' })} sortingDataKey="crUnifiedNumber" />
    ),
    dataIndex: 'crUnifiedNumber',
    key: 'crUnifiedNumber',
    render: (crUnifiedNumber) => <CellText>{crUnifiedNumber ?? '—'}</CellText>,
    width: 180,
  };
}

export default crUnifiedNumberCell;
